import React from 'react';
import ReactDOM from 'react-dom';
import Slides from '@ifeng-fe/ui_pc_slides';
import styles from './index.css';
import PropTypes from 'prop-types';
const { formatImage } = require('@ifeng-fe/public_method');

class SimpleSlider extends React.PureComponent {
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const config = {
            arrows: false,
            dots: true,
            dotsAction: 'hover',
            autoplay: true,
            autoplayInterval: 6000,
            speed: 1000,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
        };
        let contentSlide = [];

        if (content && content.map) {
            contentSlide = content.map(item => ({
                title: item.title,
                src: item && item.thumbnail ? formatImage(item.thumbnail, 790, 320) : '',
                url: item.url,
            }));
        }

        return (
            <div className={styles.slide}>
                <Slides config={config} content={contentSlide} />
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
SimpleSlider.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
SimpleSlider.defaultProps = {};

export { SimpleSlider };
export default SimpleSlider;
